import {
    StockHistoryAssignmentDto,
    StockHistoryDirection,
    StockHistoryEntryDto,
    StockHistoryOperationDto,
    StockHistoryUserDto,
} from './stock-history-entry.dto';

export class StockHistoryParty {
    readonly name: string;
    readonly warehouseCode: string;
    readonly department: string;

    constructor(dto: StockHistoryAssignmentDto) {
        this.name = userName(dto.user);
        this.warehouseCode = dto.warehouse.code;
        this.department = dto.department.abbreviation;
    }
}

export class StockHistoryEntry {
    readonly id: string;
    readonly createdAt: Date | null;
    readonly direction: StockHistoryDirection | null;
    /** `null` on an external supply, whose `actor` is who entered it. */
    readonly source: StockHistoryParty | null;
    readonly recipient: StockHistoryParty;
    readonly actor: string;
    readonly materialCode: string;
    readonly materialName: string;
    readonly materialType: string;
    readonly weightGrams: string;
    readonly note: string;

    constructor(dto: StockHistoryEntryDto) {
        // Every row carries one of the two, by `operationType`.
        const operation = <StockHistoryOperationDto>(dto.transfer ?? dto.supply);
        const { snapshot } = dto;

        this.id = operation.operationId;
        this.createdAt = operation.createdAt ? new Date(operation.createdAt) : null;
        this.direction = dto.direction;
        this.source = snapshot.source ? new StockHistoryParty(snapshot.source) : null;
        this.recipient = new StockHistoryParty(snapshot.recipient);
        this.actor = snapshot.actor ? userName(snapshot.actor) : '';
        this.materialCode = snapshot.material.code;
        this.materialName = snapshot.material.name;
        this.materialType = snapshot.materialType.name;
        this.weightGrams = operation.weightGrams;
        this.note = operation.note ?? '';
    }
}

function userName(user: StockHistoryUserDto): string {
    return `${user.lastname ?? ''} ${user.firstname ?? ''}`.trim();
}
